import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NewSubAccountRequest} from '../../../models/new-sub-account-request';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {ApiAgentService} from '../../../services/api-agent.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {EnvironmentService} from '../../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {SubAccount} from '../../../models/sub-account';
import {decodeBase64} from '../../private.component';
import {lastValueFrom} from 'rxjs';
import {CommonModule} from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-sub-accounts-assignment-form',
  templateUrl: './sub-accounts-assignment-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./sub-accounts-assignment-form.component.scss']
})
export class SubAccountsAssignmentFormComponent implements OnInit {

  @ViewChild('infoModal') infoModal: ElementRef;
  @ViewChild('addModal') addModal: ElementRef;
  pageLoading: boolean;
  requestNo: number;
  source: string;
  newSubAccountRequest: NewSubAccountRequest;
  modalTitle: string;
  modalMsg: string;
  okFunction: () => {};
  submitted: boolean;
  otpSent: boolean;
  subAccountId: number;
  loading: boolean;
  assignFormGroup: FormGroup;
  assignedSubAccounts: SubAccount[];
  accountTypes: Map<string, string> = new Map<string, string>();


  constructor(private activatedRoute: ActivatedRoute,
              private api: ApiAgentService,
              private formBuilder: FormBuilder,
              private routing: Router,
              private translate: TranslateService,
              public env: EnvironmentService) {
  }

  // @ts-ignore
  get f() {
    return this.assignFormGroup.controls;
  }

  ngOnInit(): void {
    this.submitted = false;
    this.otpSent = false;
    this.loading = false;
    this.pageLoading = true;
    this.activatedRoute.params.subscribe((params) => {
      // get request no
      this.pageLoading = false;
      this.requestNo = params['requestNo'];
      this.source = params['source'];

      this.assignFormGroup = this.formBuilder.group({
        name: ['', Validators.required],
        mobile: ['', Validators.required],
        govId: ['', Validators.required],
        absherOtp: [''],
        status: ['idle'],
        response: ['']
      });

      this.api.getSubAccountRequest(this.requestNo).then(request => {
        this.newSubAccountRequest = request;
        this.api.getSubAccountsOfRequest(this.requestNo).then(async subAccounts => {
          this.pageLoading = false;
          this.assignedSubAccounts = subAccounts;
          for (let assignedSubAccount of this.assignedSubAccounts) {
            assignedSubAccount.accountType = await this.decodeAccountType(assignedSubAccount.accountType);
          }
        }).catch(error => {
          this.pageLoading = false;
          console.log('error', error);
        });


      }).catch(error => {
        this.openInfoModal('Error', 'Cannot find the sub account request');
        this.pageLoading = false;
        console.log('error', error);
      });
    });
  }

  log(obj) {
    console.log(obj);
  }

  getStatus() {
    return this.f.status.value;
  }

  getResponse() {
    return this.f.response.value;
  }

  assignNew() {
    $(this.addModal.nativeElement).modal('show');
  }

  async submit() {
    this.submitted = true;
    if (this.assignFormGroup.valid) {
      this.submitted = false;
      this.loading = true;

      let mobile = this.f.mobile.value;
      let govId = this.f.govId.value;
      let name = this.f.name.value;
      this.assignFormGroup.patchValue({status: 'progress'});
      try {
        let response = await this.api.addSubAccount(name, mobile, govId, this.requestNo);
        if (response) {
          this.otpSent = true;
          this.subAccountId = response.id;
          this.assignFormGroup.patchValue({status: 'success', response: ''});
        } else {
          this.otpSent = false;
          this.assignFormGroup.patchValue({response: 'The operation did not succeed. Please try again.'});
        }
      } catch (e) {
        console.log(e);
        this.otpSent = false;
        this.assignFormGroup.patchValue({status: 'error'});
        if (e.error.title) {
          this.assignFormGroup.patchValue({response: e.error.title});
        } else {
          this.assignFormGroup.patchValue({response: 'The operation did not succeed. Please try again.'});
        }
      }

      this.loading = false;
    }
  }

  async submitOtp() {
    this.submitted = true;
    if (this.assignFormGroup.valid) {
      this.loading = true;
      this.submitted = false;

      let mobile = this.f.mobile.value;
      let govId = this.f.govId.value;
      let name = this.f.name.value;
      let absherOtp = this.f.absherOtp.value;
      this.assignFormGroup.patchValue({status: 'progress'});
      try {
        let response = await this.api.addSubAccountOtp(this.subAccountId, name, mobile, govId, this.requestNo, absherOtp);
        if (response) {
          this.assignFormGroup.patchValue({status: 'success', response: ''});
          window.location.reload();
        } else {
          this.assignFormGroup.patchValue({response: 'The operation did not succeed. Please try again.'});
        }
      } catch (e) {
        this.assignFormGroup.patchValue({status: 'error'});
        if (e.error.title) {
          this.assignFormGroup.patchValue({response: e.error.title});
        } else {
          this.assignFormGroup.patchValue({response: 'The operation did not succeed. Please try again.'});
        }
      }
      this.loading = false;
    }
  }

  openInfoModal(title, msg) {
    this.modalTitle = title;
    this.modalMsg = msg;
    $(this.infoModal.nativeElement).modal('show');
  }

  resetForm() {
    this.assignFormGroup.reset();
    this.otpSent = false;
    this.submitted = false;
  }

  closeWindow() {
    // [routerLink]="'/private/new-sub-accounts-requests'"
    if (this.source == 'requests') {
      this.routing.navigateByUrl('/private/new-sub-accounts-requests').then();
    } else {
      this.routing.navigateByUrl('/private/sub-accounts').then();
    }
  }

  async decodeAccountType(accountType: string) {
    let json = decodeBase64(accountType);
    console.log('json', json);
    let arr = JSON.parse(json);
    console.log('arr', arr);

    let accountTypes = [];
    for (let arrKey in arr) {
      console.log('arrKey', arrKey);
      let account = await lastValueFrom(this.translate.get(arr[arrKey]));
      accountTypes.push(account);
    }
    console.log('accountTypes', accountTypes);
    return JSON.stringify(accountTypes);
  }
}
